import { createStore } from 'vuex';
import axios from 'axios';

const base = 'https://www.dannybastiaanse.com/';

const store = createStore({
    state: {
        base,
        languages: [],
        pages: [],
        shopProducts: [],
        structure: [],
        translations: [],
    },

    getters: {
        allCategories: state => state.pages.filter(c => c.template === 3),
        base: state => state.base,
        languages: state => state.languages,
        pages: state => state.pages,
        products: state => state.pages.filter(p => p.template === 6),
        shopProducts: state => state.shopProducts,
        structure: state => state.structure,
        translations: state => state.translations,
    },

    mutations: {
        setLanguages(state, value) {
            state.languages = value;
        },
        setPages(state, value) {
            state.pages = value;
        },
        setShopProducts(state, value) {
            state.shopProducts = value;
        },
        setStructure(state, value) {
            state.structure = value;
        },
        setTranslations(state, value) {
            state.translations = value;
        },
    },

    actions: {
        getLanguages({ commit }, payload) {
            return axios.get(base + 'api/languages/', { params: payload })
                .then(response => commit('setLanguages', response.data))
                .catch(console.error);
        },

        getPages({ commit }, payload) {
            return axios.get(base + 'api/pages/', { params: payload })
                .then(response => commit('setPages', response.data))
                .catch(console.error);
        },

        getShopProducts({ commit }, payload) {
            return axios.get(base + 'api/products/', { params: payload })
                .then(response => commit('setShopProducts', response.data))
                .catch(console.error);
        },

        getStructure({ commit }, payload) {
            return axios.get(base + 'api/structure/', { params: payload })
                .then(response => commit('setStructure', response.data));
        },

        getTranslations({ commit }, payload) {
            return axios.get(base + 'api/translations/', { params: payload })
                .then(response => commit('setTranslations', response.data))
                .catch(console.error);
        },
    },
});

export default store;
